<template>
  <section class="contact-section py-16" :style="contactSectionStyle">
    <v-container class="content-container">
      <v-row justify="center" class="mb-12">
        <v-col cols="12" md="8" class="text-center">
          <h2 class="text-h3 font-weight-bold  mb-2">
            {{ $t('contact.title') }}
          </h2>
          <p class="text-h6  mb-0">
            {{ $t('contact.subtitle') }}
          </p>
        </v-col>
      </v-row>
      <v-row>
        <!-- 联系信息 -->
        <v-col cols="12" md="5">
          <ContactInfo />
        </v-col>

        <!-- 联系表单 -->
        <v-col cols="12" md="7">
          <ContactForm />
        </v-col>
      </v-row>
    </v-container>
  </section>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import ContactForm from './ContactForm.vue';
import ContactInfo from './ContactInfo.vue';

// Props
interface Props {
  backgroundImage?: string;
  isDark?: boolean;
}

const props = withDefaults(defineProps<Props>(), {
  backgroundImage: '/images/contact-bg.jpg',
  isDark: true
});

// 联系我们背景样式
const contactSectionStyle = computed(() => ({
/*  background: `linear-gradient(rgba(0, 0, 0, ${props.isDark ? '0.47' : '0.25'}), rgba(0, 0, 0, ${props.isDark ? '0.47' : '0.25'})), url(${props.backgroundImage}) no-repeat center center`,*/
  backgroundSize: 'cover',
  position: 'relative' as const
}));
</script>

<style scoped>
.contact-section {
  position: relative;
  overflow: hidden;
}

.text-white-2 {
  color: rgba(255, 255, 255, 0.9);
}

.content-container {
  position: relative;
  z-index: 1;
}

@media (max-width: 960px) {
  .contact-section {
    padding: 20px 0;
  }
}
</style> 